/* eslint-disable react/no-array-index-key */
/* eslint-disable prettier/prettier */
/* eslint-disable react/prop-types */
import { is } from 'ramda';
import React from 'react';
import styled from 'styled-components';

// import background from '../../../assets/images/stack-bg.png';
// import mainLogo from '../../../assets/images/Sports_Connect_powered by_logo_white.png';
import idSafe from '../../../assets/images/seal-id-safe.png';
import kidSafe from '../../../assets/images/seal-kid-safe.png';
import { theme } from '../../../utils/styles';
// import { Copyright, LinkWrapper } from '../components/Footer/styled-components';
// import Link from '../../common/components/Link';
// import { mediaQueries } from '../../../utils/styles';

import { Box, Center, Flex, HStack, Image, Stack } from '../components/ui';

const Shield = ({ ...props }) => <Image style={{ width: '3em' }} {...props} />;

const Description = ({ children, ...props }) => <Center {...props}>{children}</Center>;

const Wrapper = styled(Flex)`
  flex-direction: column;
  width: 100%;
  padding: 2em;
`;

const Heading = styled(Box)`
  font-size: 1.9rem;
  color: ${theme.heading};
  font-family: ${theme.barlowCondensed};
  text-align: center;
  height: auto;
  flex: 0 0 auto;
  margin-top: 1em;
`;

const Descriptions = styled(Stack)`
  width: 90%;
  margin: 1em auto;
  font-size: 1.1rem;
  text-align: center;
  font-family: ${theme.barlow};
  color: ${theme.textGray};
`;

const Column = styled(Flex)`
  flex: 1;
  flex-direction: column;
  width: 100%;
`;

const Shields = styled(Center)`
  margin-top: 2.5em;
  height: auto;
  flex: 0 0 auto;
`;

const General = ({ title, description, children }) => (
  <Wrapper>
    {title && <Heading>{title}</Heading>}
    <Descriptions spacing={3}>
      {is(Array, description) &&
        description.map((item, idx) => (
          <Description key={`description-${idx}`}>{item}</Description>
        ))}
      {is(String, description) && <Description>{description}</Description>}
    </Descriptions>
    <Column>{children}</Column>
    <Shields>
      <HStack spacing={2} mb="4em">
        <Box>
          <a
            href="https://stacksports.com/legal-privacy/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <Shield src={idSafe} alt="ID Safe Badge" />
          </a>
        </Box>
        <Box>
          <a href="https://stacksports.com/legal-COPPA/" target="_blank" rel="noopener noreferrer">
            <Shield src={kidSafe} alt="Kid Safe Badge" />
          </a>
        </Box>
      </HStack>
    </Shields>
  </Wrapper>
);

// const Page = styled.section`
//   display: flex;
//   flex-direction: column;
//   justify-content: center;
//   align-items: center;
//   background-color: #e3ecf3;
//   width: 100%;
//   min-height: 100%;
// `;
// const BackgroundImage = styled.div`
//   background: transparent url(${background}) 0% 0% padding-box;
//   background-size: cover;
//   top: -43%;
//   left: 0px;
//   width: 100%;
//   height: 1080px;
//   position: absolute;
//   z-index: 1;
// `;
// const Content = styled.section`
//   flex: 1;
//   width: 100%;
//   position: relative;
//   display: flex;
//   flex-direction: column;
//   align-content: center;
// `;
// const Footer = styled.section`
//   flex: 0 0 auto;
//   display: flex;
//   align-items: center;
//   background-color: #363636;
//   height: 48px;
//   width: 100%;
//   margin-top: 32px;
//   ${mediaQueries.sm(`
//     margin-top: 32px;
//     height: auto;
//     padding-top: 16px;
//     padding-bottom: 16px;
//   `)};
// `;
// const FooterText = styled.section`
//   display: block;
//   margin-left: 48px;
//   margin-right: 48px;
//   color: #fff;
//   font-family: Lato;
//   font-size: 12px;
//   ${mediaQueries.sm(`
//     text-align: center;
//   `)};
// `;
// const LogoContainerRow = styled.section`
//   display: flex;
//   flex-direction: row;
//   justify-content: center;
//   z-index: 2;
// `;
// const LogoContainer = styled.section`
//   flex: 0 0 auto;
//   max-width: calc(100% - 2em);
// `;
// const Logo = styled.img`
//   margin: 100px auto;
//   width: 450px;
//   max-width: 90%;
// `;

// const LoginContainer = styled.section`
//   display: flex;
//   flex-direction: row;
//   justify-content: center;
//   z-index: 2;
// `;

// const LoginBox = styled.section`
//   width: 480px;
//   max-width: 94%;
//   min-height: 480px;
//   background-color: #fff;
//   box-shadow: 0px 3px 6px #00000033;
//   display: flex;
//   flex-direction: column;
//   color: #525252;
// `;

const Row = styled.section`
  display: flex;
  flex-direction: row;
`;
// const Column = styled.section`
//   display: flex;
//   flex-direction: column;
// `;

// const HeaderContainer = styled(Row)`
//   margin-top: 60px;
//   justify-content: center;
//   font-family: 'Barlow Condensed', sans-serif;
//   font-size: 32px;
//   color: #071743;
//   text-align: center;
// `;

export const StepText = styled(Row)`
  margin-top: 24px;
  margin-left: 60px;
  margin-right: 60px;
  justify-content: center;
  text-align: center;
  font-size: 18px;
  font-family: 'Barlow', sans-serif;
`;

// const MainContent = styled(Column)`
//   margin-top: 60px;
//   justify-content: center;
//   width: 100%;
// `;

// const ShieldsContainer = styled(Row)`
//   margin-top: 48px;
//   margin-bottom: 60px;
//   justify-content: center;
// `;

// const IconContainer = styled.section``;
// const Icon = styled.img`
//   height: 52px;
//   margin: 0 3.2px;
// `;
// export const General = ({ title, text, children }) => (
//   <Page>
//     <Content>
//       <BackgroundImage />
//       <LogoContainerRow>
//         <LogoContainer>
//           <Logo src={mainLogo} />
//         </LogoContainer>
//       </LogoContainerRow>
//       <LoginContainer>
//         <LoginBox>
//           <HeaderContainer>{title}</HeaderContainer>
//           {is(Array, text) && text.map(item => <StepText>{item}</StepText>)}
//           {is(String, text) && <StepText>{text}</StepText>}
//           <MainContent>{children}</MainContent>
//           <ShieldsContainer>
//             <IconContainer>
//               <a
//                 href="https://stacksports.com/legal-privacy/"
//                 target="_blank"
//                 rel="noopener noreferrer"
//               >
//                 <Icon src={idSafe} alt="ID Safe Badge" />
//               </a>
//               <a
//                 href="https://stacksports.com/legal-COPPA/"
//                 target="_blank"
//                 rel="noopener noreferrer"
//               >
//                 <Icon src={kidSafe} alt="Kid Safe Badge" />
//               </a>
//             </IconContainer>
//           </ShieldsContainer>
//         </LoginBox>
//       </LoginContainer>
//     </Content>
//     <Footer>
//       <FooterText>
//         <Copyright>© Copyright 2012 - 2021 Stack Sports</Copyright>
//         {' | '}
//         <Copyright>All Rights Reserved</Copyright>
//         {' | '}
//         <LinkWrapper>
//           <Link to="https://stacksports.com/legal-privacy" target="_blank">
//             Privacy Policy
//           </Link>
//         </LinkWrapper>
//         {' | '}
//         <LinkWrapper>
//           <Link to="https://stacksports.com/legal-terms" target="_blank">
//             Terms of Service
//           </Link>
//         </LinkWrapper>
//         {' | '}
//         <LinkWrapper>
//           <Link to="https://stacksports.com/legal-coppa" target="_blank">
//             Children’s Policy
//           </Link>
//         </LinkWrapper>
//         {' | '}
//         <LinkWrapper>
//           SLA:{' '}
//           <Link
//             to="https://stacksports.com/stack-sports-system-license-agreement-united-states"
//             target="_blank"
//           >
//             (US)
//           </Link>{' '}
//           <Link
//             to="https://stacksports.com/stack-sports-system-license-agreement-canada"
//             target="_blank"
//           >
//             (CANADA)
//           </Link>
//         </LinkWrapper>
//       </FooterText>
//     </Footer>
//   </Page>
// );

export default General;



// WEBPACK FOOTER //
// ./src/views/sports-connect/layouts/general.js